import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import '../styles/public.css';

/* ─── SHARED LAYOUT ───────────────────────────────────────────── */
function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenu, setMobileMenu] = useState(false);
  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', fn);
    return () => window.removeEventListener('scroll', fn);
  }, []);
  const btn = { display:'inline-flex',alignItems:'center',justifyContent:'center',gap:8,padding:'10px 20px',borderRadius:'var(--radius-sm)',fontFamily:'inherit',fontSize:'0.9rem',fontWeight:600,textDecoration:'none',border:'none',cursor:'pointer' };
  const btnP = { ...btn, background:'var(--accent)', color:'var(--primary)' };
  const btnO = { ...btn, background:'transparent', color:'var(--primary)', border:'1.5px solid var(--border)' };
  const NAV_LINKS = [
    { href:'/api', label:'API' },
    { href:'/#precos', label:'Preços' },
    { href:'/sobre', label:'Empresa' },
    { href:'/ajuda', label:'Suporte' },
  ];
  return (
    <nav style={{ position:'fixed',top:0,left:0,right:0,zIndex:1000,padding:scrolled?'12px 0':'16px 0',
      background:(scrolled||mobileMenu)?'rgba(255,255,255,0.95)':'transparent',
      backdropFilter:(scrolled||mobileMenu)?'blur(20px)':'none',
      borderBottom:(scrolled||mobileMenu)?'1px solid var(--border)':'none',transition:'all 0.4s' }}>
      <div className="container" style={{ display:'flex',alignItems:'center',justifyContent:'space-between' }}>
        <Link to="/" style={{ display:'flex',alignItems:'center',gap:10,textDecoration:'none',fontWeight:700,fontSize:'1.3rem',color:'var(--primary)' }}>
          <div style={{ width:36,height:36,background:'var(--primary)',borderRadius:6,display:'flex',alignItems:'center',justifyContent:'center',color:'var(--accent)',fontWeight:700,fontSize:'1.1rem' }}>S</div>
          SimulaBank
        </Link>
        <div className="desk-nav" style={{ display:'flex',alignItems:'center',gap:28 }}>
          {NAV_LINKS.map(({href,label}) => (
            <Link key={href} to={href} style={{ textDecoration:'none',color:'var(--text-muted)',fontSize:'0.9rem',fontWeight:500 }}>{label}</Link>
          ))}
        </div>
        <div className="desk-btns" style={{ display:'flex',gap:12,alignItems:'center' }}>
          <Link to="/login" style={btnO}>Entrar</Link>
          <Link to={`https://wa.me/5561991826667?text=${encodeURIComponent('Começar com api')}`}  target="_blank" rel="noopener noreferrer" style={btnP}>Começar grátis</Link>
        </div>
        <button className="mob-toggle" onClick={() => setMobileMenu(!mobileMenu)} style={{ display:'none',flexDirection:'column',gap:4.5,background:'none',border:'none',cursor:'pointer',padding:8 }}>
          {[0,1,2].map(i => <span key={i} style={{ display:'block',width:22,height:2,borderRadius:1,background:'var(--primary)',transition:'all 0.3s',
            ...(i===0&&mobileMenu?{transform:'rotate(45deg) translate(4.5px,4.5px)'}:{}),
            ...(i===1&&mobileMenu?{opacity:0}:{}),
            ...(i===2&&mobileMenu?{transform:'rotate(-45deg) translate(4.5px,-4.5px)'}:{}) }} />)}
        </button>
      </div>
      {mobileMenu && (
        <div className="mob-menu" style={{ display:'flex',flexDirection:'column',padding:'12px 24px 20px',background:'rgba(255,255,255,0.98)',borderTop:'1px solid var(--border)' }}>
          {NAV_LINKS.map(({href,label}) => (
            <Link key={href} to={href} onClick={() => setMobileMenu(false)} style={{ textDecoration:'none',color:'var(--text)',fontSize:'0.95rem',fontWeight:500,padding:'12px 0',borderBottom:'1px solid var(--border)' }}>{label}</Link>
          ))}
          <div style={{ display:'flex',gap:10,marginTop:16 }}>
            <Link to="/login" onClick={() => setMobileMenu(false)} style={{ ...btnO,flex:1,textAlign:'center',justifyContent:'center' }}>Entrar</Link>
            <Link to={`https://wa.me/5561991826667?text=${encodeURIComponent('Começar com api')}`}  target="_blank" rel="noopener noreferrer" onClick={() => setMobileMenu(false)} style={{ ...btnP,flex:1,textAlign:'center',justifyContent:'center' }}>Começar com api</Link>
          </div>
        </div>
      )}
    </nav>
  );
}

function Footer() {
  const COLS = [
    { title:'Produto', links:[{l:'Funcionalidades',h:'/#features'},{l:'Preços',h:'/#precos'},{l:'API',h:'/api'},{l:'Changelog',h:'/changelog'}] },
    { title:'Empresa', links:[{l:'Sobre',h:'/sobre'},{l:'Blog',h:'/blog'},{l:'Contato',h:'/contato'},{l:'Carreiras',h:'/carreiras'}] },
    { title:'Suporte', links:[{l:'Central de ajuda',h:'/ajuda'},{l:'Documentação',h:'/docs'},{l:'Status',h:'/status'},{l:'WhatsApp',h:'/whatsapp'}] },
  ];
  return (
    <footer style={{ padding:'60px 0 32px',borderTop:'1px solid var(--border)' }}>
      <div className="container">
        <div className="footer-grid" style={{ marginBottom:48 }}>
          <div>
            <Link to="/" style={{ display:'flex',alignItems:'center',gap:10,textDecoration:'none',fontWeight:700,fontSize:'1.3rem',color:'var(--primary)' }}>
              <div style={{ width:36,height:36,background:'var(--primary)',borderRadius:6,display:'flex',alignItems:'center',justifyContent:'center',color:'var(--accent)',fontWeight:700,fontSize:'1.1rem' }}>S</div>
              SimulaBank
            </Link>
            <p style={{ color:'var(--text-muted)',fontSize:'0.88rem',marginTop:12,maxWidth:280,lineHeight:1.6 }}>A ferramenta definitiva para simulação e comparação de financiamento imobiliário entre múltiplos bancos.</p>
          </div>
          {COLS.map(col => (
            <div key={col.title}>
              <h4 style={{ fontSize:'0.8rem',fontWeight:600,textTransform:'uppercase',letterSpacing:'0.1em',color:'var(--text-muted)',marginBottom:16 }}>{col.title}</h4>
              {col.links.map(({l,h}) => <Link key={l} to={h} style={{ display:'block',color:'var(--text)',textDecoration:'none',fontSize:'0.9rem',padding:'4px 0' }}>{l}</Link>)}
            </div>
          ))}
        </div>
        <div className="footer-bottom" style={{ paddingTop:24,borderTop:'1px solid var(--border)',fontSize:'0.82rem',color:'var(--text-muted)' }}>
          <span>© 2026 SimulaBank. Todos os direitos reservados.</span>
          <div style={{ display:'flex',gap:24 }}>
            {['Termos de uso','Privacidade','LGPD'].map(l => <a key={l} href="#" style={{ color:'var(--text-muted)',textDecoration:'none' }}>{l}</a>)}
          </div>
        </div>
      </div>
    </footer>
  );
}

/* ════════════════════════════════════════════════════════════
   PAGE: API
════════════════════════════════════════════════════════════ */
const API_ENDPOINTS = [
  { method:'POST', path:'/v1/simulate', desc:'Simula financiamento em até 6 bancos simultaneamente', tag:'Core' },
  { method:'GET',  path:'/v1/banks', desc:'Lista bancos disponíveis e taxas atuais', tag:'Core' },
  { method:'POST', path:'/v1/simulate/batch', desc:'Processamento em lote de múltiplas simulações', tag:'Batch' },
  { method:'GET',  path:'/v1/simulate/{id}', desc:'Recupera resultado de uma simulação por ID', tag:'Core' },
  { method:'POST', path:'/v1/webhooks', desc:'Registra webhook para notificações de resultado', tag:'Webhook' },
  { method:'GET',  path:'/v1/usage', desc:'Consulta uso da API e limites da conta', tag:'Account' },
];
const METHOD_COLORS = { GET:'#059669', POST:'#3B82F6', PUT:'#D97706', DELETE:'#EF4444' };
const SDKS = [
  { lang:'C#', icon:'{ }', color:'#512BD4', desc:'Totalmente tipado com async/await e suporte a .NET 6+' },
  { lang:'Node.js', icon:'⬡', color:'#6DA55F', desc:'Promise-based com TypeScript definitions incluídas' },
  { lang:'Python', icon:'🐍', color:'#3776AB', desc:'Suporte a Python 3.8+ com dataclasses e type hints' },
  { lang:'cURL', icon:'~$', color:'#555', desc:'Exemplos prontos para teste rápido via terminal' },
];
const CODE_EXAMPLE = `// C# — Simulação multibanco
using SimulaBank.Client;

var client = new SimulaBankClient("sb_live_sua_chave");

var result = await client.SimulateAsync(new SimulationRequest {
    PropertyValue   = 500_000m,
    FinancedAmount  = 400_000m,
    TermMonths      = 360,
    BorrowerAge     = 35,
    Banks           = Bank.All   // BRB, Santander, Itaú, Inter, Bradesco, Caixa
});

// Melhor opção
var best = result.BestOption;
Console.WriteLine($"Melhor banco: {best.BankName}");
Console.WriteLine($"Primeira parcela: {best.FirstInstallment:C}");
Console.WriteLine($"CET: {best.CET:P2}");`;

export function ApiPage() {
  const revealRefs = useRef([]);
  const addReveal = el => { if (el && !revealRefs.current.includes(el)) revealRefs.current.push(el); };
  const revealStyle = { opacity:0, transform:'translateY(24px)', transition:'all 0.7s cubic-bezier(0.16,1,0.3,1)' };
  useEffect(() => {
    const obs = new IntersectionObserver(entries => entries.forEach(e => { if (e.isIntersecting) { e.target.style.opacity='1'; e.target.style.transform='translateY(0)'; } }), { threshold:0.08 });
    revealRefs.current.forEach(el => el && obs.observe(el));
    return () => obs.disconnect();
  }, []);

  const [activeTab, setActiveTab] = useState('csharp');
  const btn = { display:'inline-flex',alignItems:'center',justifyContent:'center',gap:8,padding:'12px 28px',borderRadius:'var(--radius-sm)',fontFamily:'inherit',fontSize:'0.9rem',fontWeight:600,textDecoration:'none',border:'none',cursor:'pointer' };
  const btnP = { ...btn, background:'var(--accent)', color:'var(--primary)' };
  const btnO = { ...btn, background:'transparent', color:'var(--primary)', border:'1.5px solid var(--border)' };
  const btnL = { padding:'16px 36px', fontSize:'1rem' };

  return (
    <div className="sb-page">
      <Navbar />

      {/* ── HERO ── */}
      <section className="page-hero" style={{ padding:'160px 0 100px', position:'relative', overflow:'hidden', background:'var(--primary)' }}>
        <div style={{ position:'absolute',top:-300,right:-200,width:800,height:800,background:'radial-gradient(circle, rgba(0,214,143,0.12) 0%, transparent 65%)',pointerEvents:'none' }} />
        <div style={{ position:'absolute',bottom:-100,left:-100,width:400,height:400,background:'radial-gradient(circle, rgba(59,130,246,0.08) 0%, transparent 65%)',pointerEvents:'none' }} />
        <div className="container" style={{ position:'relative',zIndex:1 }}>
          <div style={{ maxWidth:720 }}>
            <span style={{ display:'inline-flex',alignItems:'center',gap:8,padding:'6px 14px',borderRadius:100,fontSize:'0.78rem',fontWeight:600,background:'rgba(0,214,143,0.15)',color:'var(--accent)',border:'1px solid rgba(0,214,143,0.2)',marginBottom:24 }}>
              <span style={{ width:6,height:6,borderRadius:'50%',background:'var(--accent)',animation:'sbPulse 2s infinite' }} />
              Em breve — Entre na lista de espera
            </span>
            <h1 className="serif page-title" style={{ fontSize:'3.6rem',color:'#fff',marginBottom:24,letterSpacing:'-0.02em' }}>
              Motor de cálculo multibanco via <em>REST API</em>
            </h1>
            <p style={{ fontSize:'1.15rem',color:'rgba(255,255,255,0.6)',maxWidth:560,marginBottom:40,lineHeight:1.7 }}>
              Integre simulações de financiamento imobiliário diretamente no seu sistema. Cálculos SAC, MIP, DFI e CET calibrados com dados oficiais dos 6 maiores bancos do Brasil.
            </p>
            <div style={{ display:'flex',gap:16,flexWrap:'wrap' }}>
              <a href={`https://wa.me/5561991826667?text=${encodeURIComponent('Entrar na lista de espera api')}`} target="_blank" rel="noopener noreferrer" style={{ ...btnP, ...btnL }}>Entrar na lista de espera</a>
              <a href="#endpoints" style={{ ...btn, ...btnL, color:'#fff', border:'1.5px solid rgba(255,255,255,0.2)', background:'transparent' }}>Ver documentação</a>
            </div>
          </div>

          {/* Stats */}
          <div className="api-hero-stats">
            {[['6+','Bancos integrados'],['1.000+','Req/min'],['< 200ms','Latência média'],['99,9%','Uptime SLA']].map(([v,l]) => (
              <div key={l} style={{ padding:'28px 24px',background:'rgba(255,255,255,0.03)' }}>
                <div style={{ fontSize:'1.9rem',fontWeight:700,color:'var(--accent)',marginBottom:4 }}>{v}</div>
                <div style={{ fontSize:'0.82rem',color:'rgba(255,255,255,0.45)' }}>{l}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── SDKs ── */}
      <section style={{ padding:'100px 0', background:'var(--surface)' }}>
        <div className="container">
          <div ref={addReveal} style={{ ...revealStyle, textAlign:'center',maxWidth:560,margin:'0 auto 56px' }}>
            <span className="section-label">SDKs oficiais</span>
            <h2 className="serif" style={{ fontSize:'2.6rem',marginBottom:12 }}>Integre em minutos</h2>
            <p style={{ color:'var(--text-muted)',fontSize:'1rem' }}>SDKs prontos para as principais linguagens. Sem precisar lidar com HTTP raw.</p>
          </div>
          <div className="api-sdks-grid">
            {SDKS.map((s,i) => (
              <div key={s.lang} ref={addReveal} style={{ ...revealStyle,transitionDelay:`${i*0.1}s`,background:'#fff',borderRadius:'var(--radius)',padding:28,border:'1px solid var(--border)' }}>
                <div style={{ width:44,height:44,borderRadius:10,background:s.color+'18',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'1.2rem',fontWeight:700,color:s.color,marginBottom:16 }}>{s.icon}</div>
                <div style={{ fontWeight:700,fontSize:'1.05rem',marginBottom:8 }}>{s.lang}</div>
                <p style={{ fontSize:'0.85rem',color:'var(--text-muted)',lineHeight:1.55 }}>{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── CODE EXAMPLE ── */}
      <section style={{ padding:'100px 0' }}>
        <div className="container">
          <div className="api-code-split">
            <div ref={addReveal} style={revealStyle}>
              <span className="section-label">Exemplo de uso</span>
              <h2 className="serif" style={{ fontSize:'2.6rem',marginBottom:16 }}>Simples de integrar, <em>poderoso</em> por dentro</h2>
              <p style={{ color:'var(--text-muted)',marginBottom:32,lineHeight:1.7 }}>Poucas linhas de código para ter simulações precisas em 6 bancos. Resposta em JSON estruturado com todos os dados que você precisa.</p>
              <ul style={{ listStyle:'none',display:'flex',flexDirection:'column',gap:14 }}>
                {['Resposta em < 200ms','JSON estruturado e documentado','Erros padronizados (RFC 7807)','Versionamento semântico da API'].map(f => (
                  <li key={f} style={{ display:'flex',alignItems:'center',gap:10,fontSize:'0.92rem' }}>
                    <span style={{ color:'var(--accent)',fontWeight:700 }}>✓</span>{f}
                  </li>
                ))}
              </ul>
            </div>
            <div ref={addReveal} style={{ ...revealStyle,transitionDelay:'0.1s' }}>
              <div style={{ background:'var(--primary)',borderRadius:'var(--radius)',overflow:'hidden',boxShadow:'0 24px 60px rgba(10,15,30,0.15)' }}>
                <div style={{ padding:'12px 16px',borderBottom:'1px solid rgba(255,255,255,0.08)',display:'flex',alignItems:'center',gap:8 }}>
                  {['#FF5F57','#FEBC2E','#28C840'].map(c => <div key={c} style={{ width:10,height:10,borderRadius:'50%',background:c }} />)}
                  <span style={{ marginLeft:8,fontSize:'0.75rem',color:'rgba(255,255,255,0.4)',fontFamily:'JetBrains Mono,monospace' }}>SimulateAsync.cs</span>
                </div>
                <pre style={{ margin:0,padding:'24px 20px',fontSize:'0.75rem',lineHeight:1.75,color:'rgba(255,255,255,0.85)',overflowX:'auto',fontFamily:'JetBrains Mono,monospace' }}>
                  {CODE_EXAMPLE.split('\n').map((line, i) => {
                    let color = 'rgba(255,255,255,0.85)';
                    if (line.trim().startsWith('//')) color = 'rgba(255,255,255,0.3)';
                    else if (line.includes('var ') || line.includes('using ')) color = '#7DD3FC';
                    else if (line.includes('new ') || line.includes('await ')) color = '#C4B5FD';
                    else if (line.includes('"') || line.includes("'")) color = '#86EFAC';
                    return <div key={i} style={{ color }}>{line || ' '}</div>;
                  })}
                </pre>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── ENDPOINTS ── */}
      <section id="endpoints" style={{ padding:'100px 0', background:'var(--surface)' }}>
        <div className="container">
          <div ref={addReveal} style={{ ...revealStyle,textAlign:'center',maxWidth:560,margin:'0 auto 56px' }}>
            <span className="section-label">Endpoints</span>
            <h2 className="serif" style={{ fontSize:'2.6rem',marginBottom:12 }}>Referência da API</h2>
            <p style={{ color:'var(--text-muted)' }}>Endpoints disponíveis na versão v1 da API.</p>
          </div>
          <div style={{ display:'flex',flexDirection:'column',gap:2 }}>
            {API_ENDPOINTS.map((ep,i) => (
              <div key={i} ref={addReveal} style={{ ...revealStyle,transitionDelay:`${i*0.06}s`,background:'#fff',borderRadius:'var(--radius-sm)',padding:'18px 24px',border:'1px solid var(--border)',display:'flex',alignItems:'center',gap:16,flexWrap:'wrap' }}>
                <span style={{ fontFamily:'JetBrains Mono,monospace',fontSize:'0.72rem',fontWeight:700,padding:'4px 10px',borderRadius:6,background:METHOD_COLORS[ep.method]+'18',color:METHOD_COLORS[ep.method],minWidth:48,textAlign:'center' }}>{ep.method}</span>
                <code style={{ fontFamily:'JetBrains Mono,monospace',fontSize:'0.88rem',color:'var(--primary)',fontWeight:500,flex:'0 0 auto' }}>{ep.path}</code>
                <span style={{ color:'var(--text-muted)',fontSize:'0.88rem',flex:1 }}>{ep.desc}</span>
                <span style={{ fontSize:'0.7rem',fontWeight:600,padding:'3px 10px',borderRadius:100,background:'var(--surface)',color:'var(--text-muted)',border:'1px solid var(--border)' }}>{ep.tag}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── PRICING ── */}
      <section style={{ padding:'100px 0' }}>
        <div className="container">
          <div ref={addReveal} style={{ ...revealStyle,textAlign:'center',maxWidth:560,margin:'0 auto 56px' }}>
            <span className="section-label">Planos API</span>
            <h2 className="serif" style={{ fontSize:'2.6rem',marginBottom:12 }}>Preço por uso</h2>
          </div>
          <div className="g3" style={{ display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:24,maxWidth:900,margin:'0 auto' }}>
            {[
              { name:'Starter',price:'297',reqs:'10.000 req/mês',features:['6 bancos por requisição','Cálculos SAC, MIP, DFI, CET','Latência < 200ms','Suporte via email'] },
              { name:'Growth',price:'597',reqs:'50.000 req/mês',features:['Tudo do Starter','Webhooks e callbacks','Dashboard de uso','Suporte prioritário'],popular:true },
              { name:'Scale',price:'Sob consulta',reqs:'Volume ilimitado',features:['Tudo do Growth','SLA dedicado 99,9%','Infraestrutura dedicada','Gerente de conta'] },
            ].map((p,i) => (
              <div key={p.name} ref={addReveal} style={{ ...revealStyle,transitionDelay:`${i*0.1}s`,background:'#fff',borderRadius:'var(--radius)',padding:32,border:p.popular?'2px solid var(--accent)':'1px solid var(--border)',position:'relative' }}>
                {p.popular && <span style={{ position:'absolute',top:-13,left:'50%',transform:'translateX(-50%)',background:'var(--accent)',color:'var(--primary)',fontSize:'0.7rem',fontWeight:700,padding:'4px 14px',borderRadius:100,whiteSpace:'nowrap' }}>Mais escolhido</span>}
                <div style={{ fontWeight:700,fontSize:'1rem',marginBottom:8 }}>{p.name}</div>
                <div style={{ fontSize:'2rem',fontWeight:700,marginBottom:4 }}>R$ {p.price}<span style={{ fontSize:'0.85rem',fontWeight:400,color:'var(--text-muted)' }}>{p.price!=='Sob consulta'?'/mês':''}</span></div>
                <div style={{ fontSize:'0.82rem',color:'var(--accent)',fontWeight:600,marginBottom:24 }}>{p.reqs}</div>
                <ul style={{ listStyle:'none',display:'flex',flexDirection:'column',gap:10,marginBottom:28 }}>
                  {p.features.map(f => <li key={f} style={{ display:'flex',gap:8,fontSize:'0.85rem',color:'var(--text-muted)' }}><span style={{ color:'var(--accent)',fontWeight:700 }}>✓</span>{f}</li>)}
                </ul>
                <a href={`https://wa.me/5561991826667?text=${encodeURIComponent('Entrar na lista de espera api')}`} target="_blank" rel="noopener noreferrer" style={{ ...btnP,width:'100%',textAlign:'center',justifyContent:'center',background:p.popular?'var(--accent)':'var(--primary)',color:p.popular?'var(--primary)':'#fff' }}>Entrar na lista</a>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── WAITLIST CTA ── */}
      <section id="lista-espera" style={{ padding:'100px 0', background:'var(--primary)' }}>
        <div className="container" style={{ textAlign:'center' }}>
          <div ref={addReveal} style={revealStyle}>
            <span className="section-label" style={{ justifyContent:'center' }}>Lista de espera</span>
            <h2 className="serif" style={{ fontSize:'2.8rem',color:'#fff',marginBottom:16 }}>Seja um dos primeiros</h2>
            <p style={{ color:'rgba(255,255,255,0.55)',fontSize:'1.05rem',maxWidth:480,margin:'0 auto 36px' }}>A API ainda está em desenvolvimento. Deixe seu email e te avisamos quando entrar em beta.</p>
            <form onSubmit={e => e.preventDefault()} style={{ display:'flex',gap:12,maxWidth:480,margin:'0 auto',flexWrap:'wrap',justifyContent:'center' }}>
              <input type="email" placeholder="seu@email.com" style={{ flex:1,minWidth:220,padding:'14px 18px',borderRadius:'var(--radius-sm)',border:'1.5px solid rgba(255,255,255,0.12)',background:'rgba(255,255,255,0.06)',color:'#fff',fontSize:'0.95rem',fontFamily:'inherit',outline:'none' }} />
              <button type="submit" style={{ ...btnP, padding:'14px 28px', flexShrink:0 }}>Quero acesso antecipado</button>
            </form>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}